import * as yup from "yup";
import { CorrienteSchema } from "./CorrienteSchema";
import { CantidadSchema } from "./CantidadSchema";

export const ResiduoPeligrosoSchema = yup.object().shape({
  orden: yup.number().required("errors.residuoPeligroso.orden.required"),
  corriente: yup
    .object()
    .concat(CorrienteSchema)
    .required("errors.residuoPeligroso.corriente.required")
    .default(null),
  cantidad: yup
    .object()
    .concat(CantidadSchema)
    .required("errors.residuoPeligroso.cantidad.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "KG" } }),
  operacionesUnitarias: yup
    .array()
    .min(1, "errors.residuoPeligroso.operacionesUnitarias.min")
    .required("errors.residuoPeligroso.operacionesUnitarias.required")
    .default([]),
  peligrosidad: yup
    .array()
    .min(1, "errors.residuoPeligroso.peligrosidad.min")
    .required("errors.residuoPeligroso.peligrosidad.required")
    .default([]),
  descripcion: yup
    .string()
    .max(1024, "errors.residuoPeligroso.descripcion.max")
    .required("errors.residuoPeligroso.descripcion.required")
    .default(""),
  tratamiento: yup
    .object()
    .required("errors.residuoPeligroso.tratamiento.required")
    .default(null),
});
